import {PropertyBase} from "./PropertyBase";
import {Input} from "postcss";
import * as React from "react";

export class NumberProperty extends PropertyBase{
    public label:string="Label";
    private convertToPixels:boolean=true;
    private _placeholder: string;

    public SetPlaceholder(placeholder:string){
        this._placeholder=placeholder;
        return this;
    }
    public SetDoNotConvertToPixels()
    {
        this.convertToPixels=false;
    }

    public SubRenderer(): React.ReactNode {
        let value:any=parseInt(this.GetOptionValue());
        if(isNaN(value))
            value='';
        return (
            <div>
                <label style={{width:'100%'}}>{this.label}</label>
                <input style={{width:'100%'}} type={'number'} value={value} onChange={e=>{this.SetOptionValue(e.target.value!=''?e.target.value+'px':'');this.ForceUpdate()}} placeholder={this._placeholder}/>
            </div>
        )
    }

}